(function() {
  'use strict';

  angular
    .module('portfolio', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ui.bootstrap', 'toastr']);

})();

(function() {
  'use strict';

  angular
      .module('portfolio')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($scope, moment) {

      // "vm.creation" is avaible by directive option "bindToController: true"
      $scope.relativeDate = moment($scope.creationDate).fromNow();
      $scope.isCollapsed = true;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .controller('TechController', TechController);

  /** @ngInject */
  function TechController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .controller('ResumeController', ResumeController);

  /** @ngInject */
  function ResumeController() {
    var vm = this;
}
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .controller('MyResumeController', MyResumeController);

  /** @ngInject */
  function MyResumeController() {
    var vm = this;
}
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .controller('ContactController', ContactController);

  /** @ngInject */
  function ContactController() {
    var vm = this;
}
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .controller('AboutController', AboutController);

  /** @ngInject */
  function AboutController() {
    var vm = this;
}
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .controller('ProjectShowController', ProjectShowController);

  /** @ngInject */
  function ProjectShowController(ProjectService, $stateParams) {
    var vm = this;
    var id = $stateParams.projectId;
    vm.project = ProjectService.findProjectById(id);
  }
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .service('ProjectService', ProjectService);

  /** @ngInject */
  function ProjectService() {

    var svc = this;

    svc.findProjectById = function(id) {
      var projectId = parseInt(id);
      return _.find(svc.inventory, function(project) {
        return project.id === parseInt(projectId);
      });
    };

    // TODO: eventually we want to fetch the inventory from the server.
    svc.inventory = [
      {
        id: 1,
        category: 'JavaScript',
        name: 'Tic Tac Toe',
        rating: 3.8,
        description: 'A simple Tic Tac Toe game with a twist',
        imageFile: 't3.png',
        url: "http://jhkirkley.github.io/tictactoe/",
        published: "2015-11-15",
        tags: ["responsive"]
      },
      {
        id: 2,
        category: 'Ruby on Rails',
        name: 'LocationScout',
        rating: 4.2,
        description: 'A way to find where movies were filmed',
        imageFile: 'locationscout.png',
        url: "https://fast-brook-45274.herokuapp.com/",
        published: "2016-01-25",
        tags: ["bootstrap", "ruby", "postgresql"]
      },
      {
        id: 3,
        category: 'Express',
        name: 'BandBoard',
        rating: 4.6,
        description: 'A way to find bands playing in town',
        imageFile: 'bandboard.png',
        url: "https://band-board.herokuapp.com/",
        published: "2016-02-17",
        tags: ["responsive", "nodejs", "mongodb"]
      },
      {
        id: 4,
        category: 'MEAN',
        name: 'vrCade',
        rating: 4.8,
        description: 'A way to find bands playing in town',
        imageFile: 'vrcade.png',
        url: "https://vrcade.herokuapp.com/",
        published: "2016-03-01",
        tags: ["angular", "mongodb", "nodejs"]
      },
      {
        id: 5,
        category: 'Ruby On Rails',
        name: 'Drivalysis',
        rating: 4.9,
        description: 'A service to match dialysis patients with drivers',
        imageFile: 'drivalysis.png',
        url: "https://drivalysis.herokuapp.com/",
        published: "2016-03-15",
        tags: ["ruby", "bootstrap", "postgresql"]
      }
    ];
  }
})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .controller('ProjectIndexController', ProjectIndexController);

  /** @ngInject */
  function ProjectIndexController(ProjectService, $state) {
    var vm = this;
    var projects = ProjectService.inventory;
    vm.inventory = projects;
    vm.qualities = [];
    vm.tagSearch = false;
    vm.showAll = true;
    vm.clicked = function() {
       vm.tagSearch = true;
       vm.showAll = false;
    }

    vm.includeQuality = function(selection) {

        var i = vm.qualities.indexOf(selection);
        if (i > -1) {
            vm.qualities.splice(i, 1);
        } else {
            vm.qualities.push(selection);
        }
    }

    vm.click = function() {
      vm.counter += 1;
    }

    vm.goProject = function (project) {
      $state.go( 'projectDetail', { projectId : project.id } );
    };
  }

 /*   angular.module('portfolio')
   .filter('selectedTags', function() {

    return function(projects, qualities) {
        return projects.filter(function(project) {

            for (var i in project.tags) {
                if (qualities.indexOf(project.tags[i]) != -1) {
                    return true;
                }
            }
            return false;

        });

    };

})
*/
angular.module('portfolio')
.filter('selectedTags', function () {
    return function (projects, qualities) {
        var filtered = [];
        (projects || []).forEach(function (project) {
            var matches = qualities.every(function (quality) {
                return (project.tags.indexOf(quality) > -1);
            });
            if (matches) {
                filtered.push(project);
            }
        });
        return filtered;
    };
});
    angular.module('portfolio')
    .filter('inventory', function() {

    function isMatch(str, pattern) {
      return str.toLowerCase().indexOf(pattern.toLowerCase()) !== -1;
    }

    return function(inventory, searchText) {
      var projects = {
          searchText: searchText,
          out: []
      };
      angular.forEach(inventory, function (project) {
        if (isMatch(project.category   , this.searchText) ||
            isMatch(project.name       , this.searchText) ||
            isMatch(project.description, this.searchText) ) {
          this.out.push(project);
        }
      }, projects);
      return projects.out;
    };
  });
})();



(function() {
  'use strict';

  angular
    .module('portfolio')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html'
      })
       .state('about', {
        url: '/about',
        templateUrl: 'app/static_pages/about.html',
        controller: 'AboutController',
        controllerAs: 'vm'
      })
        .state('contact', {
        url: '/contact',
        templateUrl: 'app/static_pages/contact.html',
        controller: 'ContactController',
        controllerAs: 'vm'
      })
        .state('hello', {
        url: '/hello',
        templateUrl: 'app/static_pages/hello.html'
      })
        .state('resume', {
        url: '/resume',
        templateUrl: 'app/static_pages/resume.html',
        controller: 'ResumeController',
        controllerAs: 'vm'
      })
        .state('myresume', {
        url: '/myresume',
        templateUrl: 'app/static_pages/my_resume.html',
        controller: 'MyResumeController',
        controllerAs: 'vm'
      })
        .state('projects', {
        url: '/projects',
        templateUrl: 'app/projects/project.index.html',
        controller: 'ProjectIndexController',
        controllerAs: 'vm'
      })
      .state('projectDetail', {
        url: '/projects/:projectId',
        templateUrl: 'app/projects/project.show.html',
        controller: 'ProjectShowController',
        controllerAs: 'vm'
      });
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('portfolio')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('portfolio')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("portfolio").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"frontpage container\"><div class=\"hero\"><video autoplay=\"\" loop=\"\" id=\"bg-video\"><source src=\"../assets/video/full_stack.mp4\" type=\"video/mp4\"><source src=\"../assets/video/full_stack.webm\" type=\"video/webm\"><source src=\"../assets/video/full_stack.ogv\" type=\"video/ogg\"></video><div class=\"col-xs-6 left\"><div class=\"headline\"><h1>John Kirkley</h1><h2>Full Stack Web Developer</h2></div></div><div class=\"col-xs-6 right\"><div class=\"frontlinks\"><ul><li ng-class=\"{ active: $state.includes(\'projects\') }\"><a ui-sref=\"projects\">Portfolio</a></li><li ng-class=\"{ active: $state.includes(\'about\') }\"><a ui-sref=\"about\">About</a></li><li><a href=\"./assets/files/resume.pdf\" target=\"_blank\">Resume</a></li><li ng-class=\"{ active: $state.includes(\'contact\') }\"><a ui-sref=\"contact\">Contact</a></li><li><a href=\"http://jhkirkley.github.io/tech-blog/\" target=\"_blank\">Blog</a></li></ul></div></div></div></div>");
$templateCache.put("app/projects/project.index.html","<acme-navbar></acme-navbar><section class=\"container-fluid\"><article class=\"projectsearch col-xs-12 col-sm-3\"><section class=\"search\"><form role=\"search\"><span class=\"form-group searchinput\"><input type=\"text\" class=\"form-control searchtext\" name=\"search\" ng-model=\"search\" placeholder=\"Search\"></span></form></section><section class=\"container-fluid techs\"><input type=\"checkbox\" id=\"nodejs\" ng-click=\"vm.includeQuality(\'nodejs\'); vm.clicked()\"> <label for=\"nodejs\"><img src=\"../assets/images/techs/nodejs.png\" alt=\"Check me\"></label> <input type=\"checkbox\" id=\"ruby\" ng-click=\"vm.includeQuality(\'ruby\'); vm.clicked()\"> <label for=\"ruby\"><img src=\"../assets/images/techs/rails.png\" alt=\"Check me\"></label> <input type=\"checkbox\" id=\"angular\" ng-click=\"vm.includeQuality(\'angular\'); vm.clicked()\"> <label for=\"angular\"><img src=\"../assets/images/techs/angular.png\" alt=\"Check me\"></label> <input type=\"checkbox\" id=\"postgresql\" ng-click=\"vm.includeQuality(\'postgresql\'); vm.clicked()\"> <label for=\"postgresql\"><img src=\"../assets/images/techs/postgresql.png\" alt=\"Check me\"></label> <input type=\"checkbox\" id=\"mongodb\" ng-click=\"vm.includeQuality(\'mongodb\'); vm.clicked()\"> <label for=\"mongodb\"><img src=\"../assets/images/techs/mongodb.png\" alt=\"Check me\"></label> <input type=\"checkbox\" id=\"responsive\" ng-click=\"vm.includeQuality(\'responsive\'); vm.clicked()\"> <label for=\"responsive\"><img src=\"../assets/images/techs/HTML5.png\" alt=\"Check me\"></label> <input type=\"checkbox\" id=\"bootstrap\" ng-click=\"vm.includeQuality(\'bootstrap\'); vm.clicked()\"> <label for=\"bootstrap\"><img src=\"../assets/images/techs/bootstrap.png\" alt=\"Check me\"></label> <input type=\"checkbox\" id=\"sass\" ng-click=\"vm.includeQuality(\'sass\'); vm.clicked()\"> <label for=\"sass\"><img src=\"../assets/images/techs/sass.png\" alt=\"Check me\"></label></section></article><article class=\"col-lg-9 col-md-9 col-sm-9 col-xs-12 portfolio\"><div class=\"list-group-portfolio\"><div class=\"row\"><div ng-if=\"vm.showAll\" .=\"\" <div=\"\" ng-repeat=\"project in vm.inventory | filter : search | orderBy: \'published\':true\" class=\"col-sm-4 col-xs-9 projectItem\"><a ng-click=\"vm.goProject(project)\" class=\"list-group-project\"><h3>{{ project.name }}</h3><article class=\"row\"><div class=\"col-xs-5\"><img class=\"middle\" width=\"96px\" src=\"/assets/images/inventory/{{project.imageFile}}\"></div><div class=\"col-xs-7\"><dl class=\"dl-horizontal\"><dt>Category:</dt><dd>{{ project.category }}</dd><dt>Link:</dt><dd><a href=\"{{ project.url }}\" target=\"_blank\">{{project.name }}</a></dd><dt>Rating:</dt><dd>{{ project.rating }} / 5</dd><dt>Created:</dt><dd>{{ project.published | date }}</dd></dl></div></article></a><div class=\"text-center\"><button class=\"btn btn-sm btn-success\" ng-click=\"vm.goProject(project)\">Details</button></div></div></div><div ng-if=\"vm.tagSearch\" .=\"\" <div=\"\" ng-repeat=\"project in vm.inventory | selectedTags:vm.qualities | orderBy: \'published\':true\" class=\"col-sm-4 col-xs-9 projectItem\"><a ng-click=\"vm.goProject(project)\" class=\"list-group-project\"><h3>{{ project.name }}</h3><article class=\"row\"><div class=\"col-xs-5\"><img class=\"middle\" width=\"96px\" src=\"/assets/images/inventory/{{project.imageFile}}\"></div><div class=\"col-xs-7\"><dl class=\"dl-horizontal\"><dt>Category:</dt><dd>{{ project.category }}</dd><dt>Link:</dt><dd><a href=\"{{ project.url }}\" target=\"_blank\">{{project.name }}</a></dd><dt>Rating:</dt><dd>{{ project.rating }} / 5</dd><dt>Created:</dt><dd>{{ project.published | date }}</dd></dl></div></article></a><div class=\"text-center\"><button class=\"btn btn-sm btn-success\" ng-click=\"vm.goProject(project)\">Details</button></div></div></div></article></section>");
$templateCache.put("app/projects/project.show.html","<acme-navbar></acme-navbar><section class=\"container-fluid project\"><div class=\"row projectdetail\"><h1 class=\"text-center\">{{ vm.project.name }}</h1><div class=\"col-md-3 col-md-offset-2 project-stats\"><dl class=\"dl-horizontal\"><dt>Category:</dt><dd>{{ vm.project.category }}</dd><dt>Link:</dt><dd><a href=\"{{ vm.project.url }}\" target=\"_blank\">{{vm.project.name }}</a></dd><dt>Rating:</dt><dd>{{ vm.project.rating }} / 5</dd><dt>Description:</dt><dd>{{ vm.project.description }}</dd></dl><div class=\"back\"><button type=\"button\" class=\"btn btn-primary\" onclick=\"window.history.back()\">Back</button></div></div><div class=\"col-md-6 project-image\"><img class=\"middle\" width=\"80%\" src=\"/assets/images/inventory/{{vm.project.imageFile}}\"></div></div></section>");
$templateCache.put("app/static_pages/about.html","<acme-navbar></acme-navbar><div class=\"aboutpage\"><div class=\"col-sm-6 headshot\"><div class=\"frame\"><img src=\"assets/images/headshot.jpg\" alt=\"John Kirkley Headshot\"></div></div><div class=\"col-sm-6 blurb\"><div class=\"aboutipsum\"><h2>About</h2><p>I am a recent graduate of the full time web development program at General Assembly. Before GA I developed sites using the Drupal CMS. GA has helped me expand my skills in Ruby on Rails, Node js, Angular and fron end libraries. I believe web design is about delivering the best flow of information to and from the user. Please <a href=\"/contact\">contact</a> me about your web development needs.</p><p>When not working on websites I like to get outside and enjoy hiking and biking in Georgia and North Carolina. I am a food preservation technologies enthusiast and enjoy tinkering with wood, metal and electronics.</p><div><a href=\"http://github.com/jhkirkley\" target=\"_blank\"><img src=\"../assets/images/social/octocat.png\" alt=\"Github\" style=\"width:64px;border:2\"></a> <a href=\"http://linkedin.com/in/johnkirkley\" target=\"_blank\"><img src=\"../assets/images/social/linkedin_circle.png\" alt=\"Github\" style=\"width:64px;border:2\"></a> <a href=\"http://twitter.com/JohnKirkley\" target=\"_blank\"><img src=\"../assets/images/social/twitter.png\" alt=\"Github\" style=\"width:72px;border:2\"></a> <a href=\"http://www.facebook.com/john.kirkley\" target=\"_blank\"><img src=\"../assets/images/social/facebook.png\" alt=\"Github\" style=\"width:72px;border:2\"></a></div></div></div></div>");
$templateCache.put("app/static_pages/contact.html","<acme-navbar></acme-navbar><div class=\"contact\"><div class=\"wufoo\" <div=\"\" id=\"wufoo-z1b72c2415ofong\">Fill out my <a href=\"https://jkirkley.wufoo.com/forms/z1b72c2415ofong\">online form</a>.</div><div id=\"wuf-adv\" style=\"font-family:inherit;font-size: small;color:#a7a7a7;text-align:center;display:block;\">Use <a href=\"http://www.wufoo.com/partners/\">Wufoo integrations</a> and get your data to your favorite apps.</div><script type=\"text/javascript\">var z1b72c2415ofong;(function(d, t) {\nvar s = d.createElement(t), options = {\n\'userName\':\'jkirkley\',\n\'formHash\':\'z1b72c2415ofong\',\n\'autoResize\':true,\n\'height\':\'785\',\n\'async\':true,\n\'host\':\'wufoo.com\',\n\'header\':\'show\',\n\'ssl\':true};\ns.src = (\'https:\' == d.location.protocol ? \'https://\' : \'http://\') + \'www.wufoo.com/scripts/embed/form.js\';\ns.onload = s.onreadystatechange = function() {\nvar rs = this.readyState; if (rs) if (rs != \'complete\') if (rs != \'loaded\') return;\ntry { z1b72c2415ofong = new WufooForm();z1b72c2415ofong.initialize(options);z1b72c2415ofong.display(); } catch (e) {}};\nvar scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr);\n})(document, \'script\');</script></div>");
$templateCache.put("app/static_pages/hello.html","<h1>Hello</h1>");
$templateCache.put("app/static_pages/my_resume.html","<acme-navbar></acme-navbar>");
$templateCache.put("app/static_pages/resume.html","<acme-navbar></acme-navbar><object data=\"./assets/files/resume.pdf\" type=\"application/pdf\" width=\"100%\" height=\"100%\"><p>It appears you don\'t have a PDF plugin for this browser. No biggie... you can <a href=\"myfile.pdf\">click here to download the PDF file.</a></p></object>");
$templateCache.put("app/tech/tech.html","<div><acme-navbar></acme-navbar></div><div class=\"container\"><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in tech.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" ui-sref=\"home\">JOHNKIRKLEY.COM</a> <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-6\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav navbar-right\"><li ng-class=\"{ active: $state.includes(\'home\') }\"><a ui-sref=\"home\">Home</a></li><li ng-class=\"{ active: $state.includes(\'projects\') }\"><a ui-sref=\"projects\">Portfolio</a></li><li ng-class=\"{ active: $state.includes(\'about\') }\"><a ui-sref=\"about\">About</a></li><li><a href=\"./assets/files/resume.pdf\" target=\"_blank\">Resume</a></li><li ng-class=\"{ active: $state.includes(\'contact\') }\"><a ui-sref=\"contact\">Contact</a></li><li><a href=\"http://jhkirkley.github.io/tech-blog/\" target=\"_blank\">Blog</a></li><li></li></ul></div></div></nav>");}]);